export const KrispButton = ({ children, onClick, color = '#F7B500', variant = 'solid', className = '', testid, type = 'button', disabled }) => (
  <button
    type={type}
    data-testid={testid}
    data-cursor="plus"
    disabled={disabled}
    onClick={onClick}
    className={`k-btn ${variant === 'ghost' ? 'k-btn-ghost' : variant === 'dark' ? 'k-btn-dark' : ''} ${className}`}
    style={{ '--btn-c': color }}
  >
    <span>{children}</span>
  </button>
);

export default KrispButton;
